import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatCurrency = (amount) => {
  return `₹${parseFloat(amount).toFixed(2)}`;
};

export const formatTime = (date) => {
  const d = new Date(date);
  return d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
};

export const formatDate = (date) => {
  const d = new Date(date);
  return d.toLocaleDateString('en-IN', { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric' 
  });
};

export const getTimeSince = (date) => {
  const now = new Date();
  const then = new Date(date);
  const diffMs = now - then;
  const diffMins = Math.floor(diffMs / 60000);
  
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  
  return formatDate(date);
};

export const getStatusColor = (status) => {
  const colors = {
    placed: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/50',
    accepted: 'bg-blue-500/20 text-blue-400 border-blue-500/50',
    pending: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/50',
    confirmed: 'bg-blue-500/20 text-blue-400 border-blue-500/50',
    preparing: 'bg-orange-500/20 text-orange-400 border-orange-500/50',
    ready: 'bg-green-500/20 text-green-400 border-green-500/50',
    out_for_delivery: 'bg-purple-500/20 text-purple-400 border-purple-500/50',
    delivered: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/50',
    completed: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/50',
    cancelled: 'bg-red-500/20 text-red-400 border-red-500/50',
    rejected: 'bg-red-500/20 text-red-400 border-red-500/50',
  };
  return colors[status] || colors.placed;
};

export const getStatusLabel = (status) => {
  const labels = {
    placed: 'Placed',
    accepted: 'Accepted',
    pending: 'Pending',
    confirmed: 'Confirmed',
    preparing: 'Preparing',
    ready: 'Ready',
    out_for_delivery: 'Out for Delivery',
    delivered: 'Delivered',
    completed: 'Completed',
    cancelled: 'Cancelled',
    rejected: 'Rejected',
  };
  return labels[status] || status;
};